// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const inputprospectService = {};

inputprospectService.getInputprospect = function (data) {
   
  var userInputIndex = data.pageIndex || 0;
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  return lossClient({ 
    url: `/inputprospect/LoanGeneralKTA?pageSize=${data?.pageSize}&pageIndex=${decrementIndex}&prospectid=${data?.prospectid}&startProspectDate=${data?.startProspectDate}&endProspectDate=${data?.endProspectDate}&branchid=${data?.branchid}&name=${data?.name}`,
    method: "get",
  });
};

export default inputprospectService;
